/**
 * Utility function to apply resistance to a distance value.
 * @param distance - The distance to apply resistance to.
 * @param startingPoint - The point at which resistance starts to apply.
 * @param resistanceFactor - The factor that determines the strength of the resistance.
 * @returns The resisted distance value.
 */
export const resistance = (
  distance: number,
  startingPoint: number,
  resistanceFactor: number
): number => {
  'worklet';
  if (distance <= startingPoint) {
    return distance;
  }

  // Apply exponential resistance after the resistance point
  const excess = distance - startingPoint;
  const resistedExcess =
    startingPoint * (1 - Math.exp(-excess / (startingPoint * resistanceFactor)));

  return startingPoint + resistedExcess;
};
